export default __webpack_public_path__ + "static/media/scac-sponsor-logo.9678262a.png";